import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import { AppServiceService, Data } from '../services/app-service.service';
import { AuthGuard } from './auth.guard';
import { LocalSaveService } from '../services/local-save-service.service';

@Injectable({
  providedIn: 'root'
})

export class RoleGuard implements CanActivate {
  
  constructor(
  	private _router: Router,
    private _loginservice: LoginService,
    private _appService: AppServiceService,
    private _authGuard: AuthGuard,
    private localSave: LocalSaveService,
  ){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const user = this.localSave.get('usuarioPGV');

    if (user && user.ROL === next.data.ROL) {
    	return true;
    }

    this._router.navigate(['/login']);
    return false;
  }

}
